
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  title: string;
  className?: string;
}

const SectionHeading = ({ title, className }: SectionHeadingProps) => {
  return (
    <h2 
      className={cn(
        "text-3xl md:text-4xl font-bold mb-8 inline-block",
        className
      )}
    >
      {title}
      <div className="h-1 w-1/3 bg-accent mt-2"></div>
    </h2>
  );
};

export default SectionHeading;
